import type { GetCourse200AiFeedback } from './getCourse200AiFeedback';
import type { GetCourse200SectionsItem } from './getCourse200SectionsItem';
import type { GetCourse200Summary } from './getCourse200Summary';

export type GetCourse200 = {
  /**
   * 사용자별 수강 등록에 대한 코스 종합 AI 피드백 (수강생이고 피드백 존재 시 반환)
   * @nullable
   */
  aiFeedback?: GetCourse200AiFeedback;
  /** 강의 상세 설명 */
  description: string;
  sections: GetCourse200SectionsItem[];
  /** 강의 요약 정보 */
  summary: GetCourse200Summary;
};
